import { Routes, RouterModule } from '@angular/router';

const organizationExtRoutes: Routes = [
];

export const OrganizationExtRouter = RouterModule.forChild(organizationExtRoutes);